import React from 'react';
import Carousel from '../Carousel';

const TendingVideos = ({
    videos = [],
    auth,
    isAdmin,
    showAllCategoriesView,
    handleSeeAllClick,
}) => {
    return (
        <>
            {videos?.map((videos, index) => (
                <Carousel
                    key={`video-${index}`}
                    auth={auth}
                    isAdmin={isAdmin}
                    identifier="slug"
                    navUrl="video"
                    showCardMetaData={false}
                    pageName="explore"
                    courseKey={videos}
                    title={videos?.categoryName}
                    data={videos?.videos}
                    hasStartButton={false}
                    showProgress
                    showAllCourse={showAllCategoriesView}
                    seeAllBtnFn={handleSeeAllClick}
                    cardWidth="300px"
                    cardWHeight="169px"
                    cardRatio="16/9"
                />
            ))}
        </>
    );
};

export default TendingVideos;
